import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import useAuth from './hooks/useAuth';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Jobs from './pages/Jobs';
import CreateJob from './pages/CreateJob';
import JobDetail from './pages/JobDetail';
import Logs from './pages/Logs';

export default function AppRoutes() {
  const { token, login, logout } = useAuth();
  return (
    <Routes>
      <Route path="/" element={token ? <Dashboard token={token} onLogout={logout} /> : <Landing />} />
      <Route path="/login" element={<Login onLogin={login} />} />
      <Route path="/signup" element={<Signup onLogin={login} />} />
      <Route path="/jobs" element={token ? <Jobs token={token} /> : <Navigate to="/login" />} />
      <Route path="/jobs/new" element={token ? <CreateJob token={token} /> : <Navigate to="/login" />} />
      <Route path="/jobs/:id" element={token ? <JobDetail token={token} onLogout={logout} /> : <Navigate to="/login" />} />
      <Route path="/logs" element={token ? <Logs token={token} /> : <Navigate to="/login" />} />
    </Routes>
  );
}
